



















































































































import SubmitBtn from '@/components/Common/SubmitBtn.vue';
import InsuranceCommissionList from './list/InsuranceCommissionList.vue';
import OfferItemCommissionList from './list/OfferItemCommissionList.vue';
import ServiceFeeCommissionList from './list/ServiceFeeCommissionList.vue';
import AccommodationCommissionList from './list/AccommodationCommissionList.vue';
import UnsettledPayBackDialog from './dialog/UnsettledPayBackDialog.vue';
import SubmissionSettledDialog from './dialog/SubmissionSettledDialog.vue';
import SubmissionConfirmDialog from './dialog/SubmissionConfirmDialog.vue';
import UnsettledSubmissionDialog from './dialog/UnsettledSubmissionDialog.vue';
import SettlingUploadStatementDialog from './dialog/SettlingUploadStatementDialog.vue';
import { getBmsConfigByKeyApi, unsettledCommissionApi, inSettlementApi } from '@/api/index';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { start } from 'repl';
import { getCurrentDateTime } from '@/utils/function_utils';

@Component({
  name: 'unsettledComponent',
  components: {
    SubmitBtn,
    InsuranceCommissionList,
    OfferItemCommissionList,
    ServiceFeeCommissionList,
    AccommodationCommissionList,
    UnsettledPayBackDialog,
    SubmissionSettledDialog,
    SubmissionConfirmDialog,
    UnsettledSubmissionDialog,
    SettlingUploadStatementDialog,
  }
})
export default class extends Vue {
  @Prop() public submitSettlementTips!: string;

  public commissionSettledTips = '';
  public activeNames = ['1', '2', '3', '4']
  public hasSettling = false; // 是否有结算中的账单，如果是，则不可提交结算
  public settlingOptTime = '';
  public dialogTableVisible = false; // 核对账单或差异提交 dialog
  public dialogPayBackVisible = false; // 有负账单未确认勾选 dialog
  public dialogSubmitSettledVisible = false; // 提交结算dialog
  public dialogConfirmVisible = false; // 差异提交或账单提交成功 dialog
  public isSelectionTable = false;
  public isDifferentialSubmit = false; // 是否是差异提交
  public dialogUploadFileVisible = false;
  public submitSettlementDateTime: any = '';
  public offerItemCommissionDtoList: any[] = []; // 留学申请
  public insuranceCommissionDtoList: any[] = []; // 留学保险
  public accommodationCommissionDtoList: any[] = []; // 留学住宿
  public serviceFeeCommissionDtoList: any[] = []; // 留学服务费
  public allTableSelects: any = {
    offerItem: [],
    insurance: [],
    accommodation: [],
    serviceFee: [],
  };
  // 用于操作处理
  public allTableSelectsCopy: any = {
    offerItem: [],
    insurance: [],
    accommodation: [],
    serviceFee: [],
    remark: ''
  }
  // 需要处理的负账单
  public needPayBackCommission: any = {
    offerItem: [],
    insurance: [],
    accommodation: [],
    serviceFee: []
  }
  public uploadESignInfo = {
    signFlag: true,
  };
  public totalCommission: any = [];

  get hasSettlingCommissionTips() {
    return this.$t('index.hasSettlingCommissionTips', {
      time: this.settlingOptTime ? getCurrentDateTime(this.settlingOptTime).split(' ')[0] : '--'
    }) as string;
  }

  public mounted() {
    this.getDatas()
  }

  public getBmsConfigByKey() {
    return new Promise(async (resolve) => {
      try {
        const { data } = await getBmsConfigByKeyApi();
        if (data.data) {
          const value = JSON.parse(data.data.value1);
          const start = value.startDate;
          const end = value.endDate;
          const now = new Date().getDate();
          if (now < start || now > end) {
            this.$message.warning(this.$t('index.commissionSettledTips', { start, end }) as string)
            this.commissionSettledTips = this.$t('index.commissionSettledTips', { start, end }) as string;
            return resolve(false);
          }
        }
        resolve(true);
      } catch (error) {
        resolve(true);
      }
    })
  }

  public async checkHasSettling() {
    try {
      const { data } = await inSettlementApi();
      if (data.data.length) {
        this.hasSettling = true;
        this.settlingOptTime = data.data[0].optTime || '';
      } else {
        this.hasSettling = false;
        this.settlingOptTime = '';
      }
    } catch (err) {
      //
    }
  }

  // 未结算佣金
  public async getDatas() {
    const { data } = await unsettledCommissionApi();
    this.offerItemCommissionDtoList = data.data.studentOfferItemCommissionDtoList || [];
    this.accommodationCommissionDtoList = data.data.studentAccommodationCommissionDtoList || [];
    this.insuranceCommissionDtoList = data.data.studentInsuranceCommissionDtoList || [];
    this.serviceFeeCommissionDtoList = data.data.studentServiceFeeCommissionDtoList || [];
    this.totalCommission = data.data.totalCommission;
    this.allTableSelects = {
      offerItem: [],
      insurance: [],
      accommodation: [],
      serviceFee: [],
    }
    this.checkHasSettling();
  }
  // statusReview (value = "预审状态：提差异-1/未审核0/已审核1");
  public getNeedPayBackCommissionList() {
    const diffSubmitNeedPayBack: any = {
      offerItem: [],
      insurance: [],
      accommodation: [],
      serviceFee: []
    };
    const offerItem = this.offerItemCommissionDtoList.filter((item) => {
      if (item.amountActual*1 < 0 && item.statusReview === -1) {
        diffSubmitNeedPayBack.offerItem.push(item);
      }
      return (item.amountActual*1 < 0 && item.statusReview === 1) // && !tableSelects.offerItem.find((item2: any) => item2.id === item.id)
    });
    // 暂时只需要留学申请部分
    // const insurance = this.insuranceCommissionDtoList.filter((item) => {
    //   if (item.amountActual*1 < 0 && item.statusReview === -1) {
    //     diffSubmitNeedPayBack.insurance.push(item);
    //   }
    //   return (item.amountActual*1 < 0 && item.statusReview === 1) // && !tableSelects.insurance.find((item2: any) => item2.id === item.id)
    // });
    // const accommodation = this.accommodationCommissionDtoList.filter((item) => {
    //   if (item.amountActual*1 < 0 && item.statusReview === -1) {
    //     diffSubmitNeedPayBack.accommodation.push(item);
    //   }
    //   (item.amountActual*1 < 0 && item.statusReview === 1) // && !tableSelects.accommodation.find((item2: any) => item2.id === item.id)
    // });
    // const serviceFee = this.serviceFeeCommissionDtoList.filter((item) => {
    //   if (item.amountActual*1 < 0 && item.statusReview === -1) {
    //     diffSubmitNeedPayBack.serviceFee.push(item);
    //   }
    //   return (item.amountActual*1 < 0 && item.statusReview === 1) // && !tableSelects.serviceFee.find((item2: any) => item2.id === item.id)
    // });
    const needPayBack = {
      offerItem,
      insurance: [],
      accommodation: [],
      serviceFee: []
    };
    // 差异提交状态的负账单, 需要优先处理的所有负账单
    return { diffSubmitNeedPayBack, needPayBack };
  }
  // 差异提交成功后续操作
  public setSubmitSettlementDateTime(dateTime: string) {
    this.submitSettlementDateTime = dateTime;
    this.dialogConfirmVisible = true;
  }
  // 提交结算
  public submitSettlement(params: any) {
    params.flag = false;
    this.uploadESignInfo = Object.assign({}, this.uploadESignInfo, params);
    this.dialogUploadFileVisible = true;
  }

  public submitSettlementSuccess() {
    this.dialogUploadFileVisible = false;
    const dateTime = new Date().getTime();
    this.submitSettlementDateTime = dateTime;
    this.dialogConfirmVisible = true;
    // this.toSettlingTab();
  }
  // public updateFilesSuccess() {
  //   this.dialogUploadFileVisible = false;
  //   this.$confirm(`<div style="display: flex;justify-content: center;align-items: center;font-size: 20px;">${this.$t('common.submitSuccess') as string}</div>`, this.$t('common.tip') as string, {
  //     confirmButtonText: this.$t('login.confirm') as string,
  //     dangerouslyUseHTMLString: true,
  //     type: 'success',
  //     showClose: false,
  //     showCancelButton: false,
  //     center: true,
  //     closeOnClickModal: false,
  //     closeOnPressEscape: false,
  //     customClass: 'settling-confirm-box',
  //     confirmButtonClass: 'confirm-btn'
  //   }).then(() => {
  //     // this.getDatas();
  //   })
  // }

  // 差异提交第一步（弹出勾选的差异提交列表）
  public handleDifferentialSubmit() {
    const allSelects = this.allTableSelects;
    this.allTableSelectsCopy = Object.assign({}, allSelects);
    if (!allSelects.offerItem.length) {
      this.$message.error(this.$t('message.differentialSubmissionConfirm2') as string);
      return;
    }
    this.isDifferentialSubmit = true;
    this.dialogTableVisible = true;
  }

  public handleSettlementBtnClick() {
    if (this.hasSettling) {
      this.$message.warning(this.hasSettlingCommissionTips);
    }
  }

  public async handleSubmitSettlement() {
    if (this.submitSettlementTips) {
      return this.$message.error(this.submitSettlementTips);
    }
    // 4744暂时隐藏
    // const isSettledDate = await this.getBmsConfigByKey();
    // if (!isSettledDate) {
    //   this.hasSettling = true;
    //   return;
    // }
    this.isDifferentialSubmit = false;
    const { diffSubmitNeedPayBack, needPayBack } = this.getNeedPayBackCommissionList();
    this.needPayBackCommission = needPayBack;
    const allSelects = this.allTableSelects;
    this.allTableSelectsCopy = Object.assign({}, allSelects);
    // 差异提交中存在负账单时，需要等到差异提交的负账单处理完才能重新发起结算
    // 暂时只需要留学申请部分
    //  || diffSubmitNeedPayBack.insurance.length || diffSubmitNeedPayBack.accommodation.length || diffSubmitNeedPayBack.serviceFee.length
    if (diffSubmitNeedPayBack.offerItem.length) {
      this.$message.error(this.$t('message.unsettledPayBackStatementMessage') as string);
      return;
    }
    // 存在负账单时，需要先处理负账单
    // 暂时只需要留学申请部分
    // || allSelects.insurance.length || allSelects.accommodation.length || allSelects.serviceFee.length
    if (allSelects.offerItem.length) {
      // || needPayBack.insurance.length || needPayBack.accommodation.length || needPayBack.serviceFee.length
      if (needPayBack.offerItem.length && !this.isNeedPayBackAllSelected()) {
        this.dialogPayBackVisible = true;
      } else {
        this.dialogTableVisible = true;
      }
    } else {
      this.$message.error(this.$t('message.pleaseSelectSettledMessage') as string);
    }
  }

  public isNeedPayBackAllSelected(): boolean {
    const needPayBack = this.needPayBackCommission;
    const allSelects = this.allTableSelects;
    if (allSelects.offerItem.length < needPayBack.offerItem.length) {
      return false;
    } else {
      return needPayBack.offerItem.every((item: any) => {
        return allSelects.offerItem.some((item2: any) => item2.id === item.id);
      });
    }
  }

  public settlementSubmit(data: any) {
    this.allTableSelectsCopy = Object.assign({}, data);
    console.log(data);
    this.dialogSubmitSettledVisible = true;
  }
  // 负账单差异提交
  public differentialUnsettledPayBackSubmit(datas: any) {
    this.allTableSelectsCopy = datas;
    this.isDifferentialSubmit = true;
    this.dialogTableVisible = true;
  }
  // 负账单提交结算
  public settlementUnsettledPayBackSubmit(data: any) {
    const allTableSelects = this.allTableSelects;
    const filter = allTableSelects.offerItem.filter((item: any) => {
      return !data.offerItem.some((item2: any) => item2.id === item.id);
    })
    if (filter.length) {
      data.offerItem = [...data.offerItem, ...filter];
    }
    this.allTableSelectsCopy = data;
    this.isDifferentialSubmit = false;
    this.dialogTableVisible = true;
  }

  public handleListSelect(type: string, row: any) {
    switch(type) {
      case 'offerItem':
        this.allTableSelects.offerItem = row;
        break;
      // 暂时只需要留学申请部分
      // case 'insurance':
      //   this.allTableSelects.insurance = row;
      //   break;
      // case 'accommodation':
      //   this.allTableSelects.accommodation = row;
      //   break;
      // case 'serviceFee':
      //   this.allTableSelects.serviceFee = row;
      //   break;
    }
  }
  public toSettlingTab() {
    this.$emit('changeTab', { name: 'Settling' });
  }
}
